import React from 'react';
import { Grid, Container, Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    const element = <FontAwesomeIcon icon={faPaperPlane} />

    return (
        <Container>
            <Grid id='contact' style={{ color: '', display: 'flex', justifyContent: 'center', marginTop: '100px' }} container spacing={2}>
                <Grid item xs={12} md={6} className="contact">
                    <h4 style={{ textAlign: 'center' }}>Send me Feedback</h4>
                    <hr />
                    <form action="https://formsubmit.co/rafiqahamed.tanim@gmail.com" method="POST" className="contact-form">
                        <input type="email" placeholder='Email' name='email' required='true' />
                        <input type="text" placeholder='Subject' name='subject' required='true' />
                        <textarea type="text" placeholder='Message' name='message' required='true' />
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button type='submit' variant="contained">Send<span style={{ marginLeft: '5px' }}>{element}</span></Button>
                        </div>

                    </form>
                </Grid>
            </Grid>
            <br />
            <div style={{ display: 'flex', justifyContent: 'center' }}> <p className='copyright Footer'>Copyright &copy;{new Date().getFullYear()} | All Rights Reserved by OakFrog</p></div>

        </Container >
    );
};

export default Footer;